export const messages = {
  en: {
    myItemOutAuditOrders: {
      title: 'Pending Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNo: 'Order No',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      itemDistribution: 'Item Distribution',
      audit: 'Audit'
    }
  },
  zh: {
    myItemOutAuditOrders: {
      title: '待办单',
      back: '返回',
      refresh: '刷新',
      orderNo: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      itemDistribution: '物品发放',
      audit: '审批'
    }
  }
}